import axios from 'axios';
import {clearStorage, getStorage, getToken} from '../utils/auth';
import router from '../router';
import { Message } from 'element-ui';
import store from '@/store';
import Vue from "vue";

// 动态获取基础 URL
const base_url = process.env.VUE_APP_URL || 'https://cirapi.zhuoshangsoft.com';

const service = axios.create({
    baseURL: base_url,
    timeout: 30000
});

// 请求拦截器
service.interceptors.request.use((config) => {
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded';

    const params = new URLSearchParams(config.data || '');
    const dynamicParams = {
        version: process.env.VUE_APP_VERSION,
        timezone: getStorage('timezone') || 8,
        language: store.getters.language,
        token: getToken(),
        host: process.env.NODE_ENV === 'development' ? 'localhost:9527' : window.location.host
    };

    Object.entries(dynamicParams).forEach(([key, value]) => {
        params.append(key, typeof value === 'string' ? value.trim() : value);
    });

    config.data = params.toString();
    return config;
}, (error) => {
    console.error('Request Error:', error);
    return Promise.reject(error);
});

// 响应拦截器
let errorTimer = null;
service.interceptors.response.use(
    (response) => response.data,
    (error) => {
        if (!error.response) {
            showError('网络连接异常');
            return Promise.reject(error);
        }

        const { status } = error.response;
        switch (status) {
            case 401: handleUnauthorized(); break;
            case 403: showError('无权访问', { once: true }); break;
            default: showError(`请求失败 (${status})`);
        }

        return Promise.reject(error);
    }
);

// 封装错误提示函数
function showError(message, options = {}) {
    if (options.once && errorTimer) return;

    Message({
        message,
        type: 'warning',
        offset: 360
    });

    if (options.once) {
        errorTimer = setTimeout(() => {
            errorTimer = null;
        }, 2000);
    }
}

// 401 处理函数
function handleUnauthorized() {
    if (getToken()) {
        showError('登录超时');
        Vue.prototype.$EventBus.$emit('exitIM')
        clearStorage()
        localStorage.clear()
        router.push('/login');
    }
}

// 导出
export const axiosInstance = service;
export default {
    install(Vue) {
        Vue.prototype.$axios = service;
        Vue.prototype.$updateApiBaseUrl = (url) => service.defaults.baseURL = url;
    }
};
